import React from 'react';
import PropTypes from 'prop-types';

import Form from 'react-bootstrap/Form';

import CMSContent from '../CMSContent/index.jsx';

import CallToAction from './CallToAction/index.jsx';

import BEM from '@scripts/utilities/bem.js';
import CurrencyFormatter from '@scripts/utilities/currency.js';


class TierForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 0,
      loading: false
    };

    // update the default selected option if a default has been given.
    if (props.default && props.variants) {
      for (var i = 0; i < props.variants.length; i++) {
        if (props.variants[i].id == props.default) {
          this.state.selected = i;
          break;
        }
      }
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.onLengthChange = this.onLengthChange.bind(this);
  }

  onLengthChange(event) {
    this.setState({ selected: event.target.value });
  }

  onSubmit(event) {
    if (this.props.onSubmit) {
      this.props.onSubmit(event);
    }
  }

  render() {
    var content = [];
    var lengthOptions = [];

    var selectedVariant = this.props.variants[this.state.selected];

    var currentProductId = this.props.currentProductId;
    var upgrade = false;

    for (var i = 0; i < this.props.variants.length; i++) {
      var variant = this.props.variants[i];
      var current = null;

      // if the member's current product is "less" than the selected product,
      // mark it as an upgrade. The variant list is ordered, so later variants
      // are considered upgrades to earlier ones.
      if (currentProductId && (variant.id == currentProductId)) {
        current = ' - Current';

        if (this.state.selected > i) {
          upgrade = true;
        }
      }

      lengthOptions.push(
        <option key={i} value={i}>
          {this.props.title}
          {' '}
          {variant.length}
          {' - '}
          {this.props.currency}
          {' '}
          {CurrencyFormatter(variant.price, false)}
          {current}
        </option>
      );
    }

    // membership length selector
    if(currentProductId) {
      content.push(
          <div key="length" className="my-3">
            <Form.Group className="my-2">
              <Form.Label>
                <strong></strong>
              </Form.Label>
              <Form.Control
                  as="select"
                  name="membership-length"
                  custom
                  required
                  value={this.state.selected}
                  onChange={this.onLengthChange}
              >
                {lengthOptions}
              </Form.Control>
            </Form.Group>
          </div>
      );
    }
    // price text and "add to cart"
    var ctaProps = {
      key: 'cta',
      featured: this.props.featured,
      submitting: this.props.submitting,
      onSubmit: this.onSubmit,
      selected: selectedVariant,
      currency: this.props.currency
    };
    
    // Set the button text.
    if (currentProductId) { // Upgrade/downgrade.
      if (this.props.upgrade || upgrade) {
        ctaProps.buttonText = 'Upgrade to ' + this.props.title;
      } else {
        ctaProps.buttonText = 'Downgrade to ' + this.props.title;
      }
    } else if (selectedVariant.trial) { // Free trial.
      ctaProps.buttonText = 'Start Now';
      ctaProps.buttonText = ctaProps.buttonText + ' - ' + CurrencyFormatter(selectedVariant.trial.price, false) +
        ' for ' + selectedVariant.trial.duration; 
    } else { // Default.
      ctaProps.buttonText = 'Choose ' + this.props.title;
    }
    content.push(React.createElement(
      CallToAction,
      ctaProps
    ));


    return (
      <div className="cs-product-matrix-item__pricing">
        <hr />
        {content}
      </div>
    );
  }
}


TierForm.propTypes = {
  'default': PropTypes.number,
  currency: PropTypes.string
};


class ProductForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event) {
    this.setState({ submitting: true });
  }

  render() {
    var content = [];
    var tiers = this.props.tiers;

    // this will be set to the member's current product ID during a switch.
    var currentProductId = this.props.currentProductId;
    var upgrade = false;
    var current

    if (tiers && tiers.length) {
      var inner = [];

      for (var i = 0; i < tiers.length; i++) {
        var tier = tiers[i];

        var variant = undefined;
        var preHeader = undefined;
        var tierFeatured = false;

        var currentVariantIndex = undefined;

        if (currentProductId) {
          currentVariantIndex = this.tierProductIndex(tier, currentProductId);
        }

        if (typeof currentVariantIndex == 'number') {
          var tmp = tier.variants[currentVariantIndex];

          content.push(
            <div key="current" className="my-3 my-lg-0">
              <CMSContent>
                <p><strong className="has-brand-orange-color">Your Current Subscription:</strong> {tier.title} {tmp.length}</p>
              </CMSContent>
            </div>
          );
        }

        // highlight featured tier, but not if we're switching subscriptions
        if (tier.featured && ! currentProductId) {
          variant = 'feature';
          tierFeatured = true;
          preHeader = (
            <p className="cs-product-matrix-item__pre-header">Most popular</p>
          );
        }

        var features = undefined;
        if (tier.features && tier.features.length) {
          var tmp = [];

          for (var j = 0; j < tier.features.length; j++) {
            var feature = tier.features[j];

            if (feature.title && feature.description) {
              tmp.push(
                <li key={j}>
                  <strong>{feature.title}</strong>{' - '}{feature.description}
                </li>
              );
            } else if (feature.title) {
              tmp.push(
                <li key={j}><strong>{feature.title}</strong></li>
              );
            } else if (feature.description) {
              tmp.push(
                  <li key={j} dangerouslySetInnerHTML={{__html: feature.description}}></li>
              );
            }
          }

          var featureListStyle = 'dark';
          if (variant=='feature') {
            featureListStyle = 'light';
          }

          features = (
            <React.Fragment>
              <ul className={BEM.classString('cs-feature-list', featureListStyle) + ' cs-product-matrix-item__include-list'}>
                {tmp}
              </ul>
            </React.Fragment>
          );
        }
          if (tier.title == "Pro" || tier.title == "Platinum") {
              upgrade = true;
              inner.push(
                  <div key={i} className="cs-product-matrix__item">
                      <div className={BEM.classString('cs-product-matrix-item', variant)}>
                          <div className="cs-product-matrix-item__header">
                              {preHeader}
                              <h2 className="cs-product-matrix-item__title">{tier.title}</h2>
                              <p
                                  className="cs-product-matrix-item__tagline"
                                  dangerouslySetInnerHTML={{__html: tier.tagline}}
                              />
                              <hr className="product-matrix-item__hr"/>
                          </div>
                          <div className="cs-product-matrix-item__details">
                              {features}
                              <TierForm
                                  title={tier.title}
                                  featured={tierFeatured}
                                  variants={tier.variants}
                                  default={tier.default}
                                  onSubmit={this.onSubmit}
                                  submitting={this.state.submitting}
                                  upgrade={upgrade}
                                  currentProductId={currentProductId}
                                  currency={this.props.currency}
                              />
                          </div>
                      </div>
                  </div>
              );
          }
        // check whether the tier includes the member's current product, so
        // we can flag future tiers as upgrades.
        if (typeof currentVariantIndex == 'number') {
          upgrade = true;
        }
      }

      content.push(
        <div key="matrix" className="cs-product-matrix">
          {inner}
        </div>
      );
    }

    return content;
  }

  tierProductIndex(tier, variantId) {
    var result = undefined;

    if (variantId && tier && tier.variants) {
      for (var i = 0; i < tier.variants.length; i++) {
        if (tier.variants[i].id == variantId) {
          result = i;
          break;
        }
      }
    }


    return result;
  }
}


ProductForm.propTypes = {
  currentProductId: PropTypes.number,
  currency: PropTypes.string,
  tiers: PropTypes.array
};


export default ProductForm;

